import Box from '@mui/material/Box'
import {useEffect, useState} from 'react'
import ApiService from '../../../common/ApiCalls'
import {Select, Text} from '../../1elements'

const ServiceTypeDropDown = ({value, onChange}) => {
    const [options, setOptions] = useState([])

    const getServiceTypeOptions = async () => {
        const serviceTypes = await ApiService().getAllServiceTypes()
        setOptions(serviceTypes)
    }

    useEffect(()=>{
        getServiceTypeOptions()
    }, [])

    return (
        <Box sx={{ maxWidth: '400px' }}>
            <Text type={'fieldLabel'}>Service Type</Text>
            <Select options={options} optionLabelKey={'service_type'} value={value} onChange={onChange} helperText={'Select One'}
                    optionIdKey={'service_type_id'}/>
        </Box>
    )
}

export default ServiceTypeDropDown
